const projects = {
  ShipTrack: [
    "/shiptrack/1.jpeg",
    "/shiptrack/2.jpeg",
    "/shiptrack/3.jpeg",
    "/shiptrack/4.jpeg",
    "/shiptrack/5.jpeg",
  ],
  Crownivext: [
    "/crowninvext/1.jpeg",
    "/crowninvext/2.jpeg",
    "/crowninvext/3.jpeg",
    "/crowninvext/4.jpeg",
  ],
  Royal_Liberty_School: [
    "/royallib/1.jpeg",
    "/royallib/2.jpeg",
    "/royallib/3.jpeg",
    "/royallib/4.jpeg",
    "/royallib/5.jpeg",
  ],
  Wayhacks: [
    "/wayhacks/1.png",
    "/wayhacks/2.png",
    "/wayhacks/3.png",
    "/wayhacks/4.png",
    "/wayhacks/5.png",
    "/wayhacks/6.png",
    "/wayhacks/7.png",
    "/wayhacks/8.png",
  ],
  cryptauxo: [
    "/crypta/c1.png",
    "/crypta/c2.png",
    "/crypta/c3.png",
    "/crypta/c4.png",
    "/crypta/c5.png",
    "/crypta/c6.png",
    "/crypta/c7.png",
    "/crypta/c8.png",
    "/crypta/c9.png",
    "/crypta/c10.png",
  ],
  Hotel: [
    "/hkn-framework/2025-03-20 (8).png",
    "/hkn-framework/2025-03-20 (9).png",
    "/hkn-framework/2025-03-20 (10).png",
    "/hkn-framework/2025-03-20 (11).png",
    "/hkn-framework/2025-03-20 (12).png",
  ],
  Coffee_Shop: [
    "/coffee/2025-03-20 (23).png",
    "/coffee/2025-03-20 (24).png",
    "/coffee/2025-03-20 (25).png",
    "/coffee/2025-03-20 (26).png",
    "/coffee/2025-03-20 (27).png",
    "/coffee/2025-03-20 (28).png",
    "/coffee/2025-03-20 (29).png",
    "/coffee/2025-03-20 (30).png",
    "/coffee/2025-03-20 (31).png",
    "/coffee/2025-03-20 (32).png",
    "/coffee/2025-03-20 (33).png",
    "/coffee/2025-03-20 (34).png",
    "/coffee/2025-03-20 (35).png",
    "/coffee/2025-03-20 (36).png",
    "/coffee/2025-03-20 (37).png",
  ],
  Flower_Arena: [
    "/flower/2025-03-20 (13).png",
    "/flower/2025-03-20 (14).png",
    "/flower/2025-03-20 (15).png",
    "/flower/2025-03-20 (16).png",
    "/flower/2025-03-20 (17).png",
    "/flower/2025-03-20 (18).png",
    "/flower/2025-03-20 (19).png",
    "/flower/2025-03-20 (20).png",
    "/flower/2025-03-20 (21).png",
    "/flower/2025-03-20 (22).png",
  ],
  mobile_screens: [
    "/mobile/grocery-app.JPEG",
    "/mobile/9158980_4086813.jpg",
    "/mobile/1.png",
  ],
  mobile_resturant: [
    "mobile/template.jpg",
    "/mobile/2.png",
    "/mobile/3.png",
    "/mobile/5.png",
    "/mobile/Happy Meals Food Delivery App UI Kit.jpeg",
  ],
  mobile_furniture: [
    "/mobile/screen1.png",
    "/mobile/screen2.png",
    "/mobile/51.png",
    "/mobile/21.png",
  ],
};
export default projects;
